<template>
  <table class="pcd-component-position" cellpadding="0" cellspacing="0" :title="text" @dblclick="onDblClick">
    <tr>
      <td :data-position="position1"></td>
      <td :data-position="position2" class="ellipsis">{{text}}</td>
      <td :data-position="position3"><i class="el-icon-close" @click.stop="onClick"></i></td>
    </tr>
  </table>
</template>

<script>

export default {
  name: 'drop-position',
  props: {
    text: { type: String, required: true },
    dropMode: { type: String, required: false }
  },
  data () {
    return {
      position1: 'before',
      position2: 'in',
      position3: 'after'
    }
  },
  created () {
    let dropMode = this.dropMode || 'before,in,after'
    dropMode = ',' + dropMode + ','

    if (dropMode.indexOf(',none,') !== -1) {
      this.position1 = 'none'
      this.position2 = 'none'
      this.position3 = 'none'
    } else {
      let hasBefore = dropMode.indexOf(',before,') !== -1
      let hasIn = dropMode.indexOf(',in,') !== -1
      let hasAfter = dropMode.indexOf(',after,') !== -1
      if (hasBefore) {
        if (hasIn) {
          if (hasAfter) {
            this.position1 = 'before'
            this.position2 = 'in'
            this.position3 = 'after'
          } else {
            this.position1 = 'before'
            this.position2 = 'in'
            this.position3 = 'in'
          }
        } else {
          if (hasAfter) {
            this.position1 = 'before'
            this.position2 = 'after'
            this.position3 = 'after'
          } else {
            this.position1 = 'before'
            this.position2 = 'before'
            this.position3 = 'before'
          }
        }
      } else {
        if (hasIn) {
          if (hasAfter) {
            this.position1 = 'in'
            this.position2 = 'in'
            this.position3 = 'after'
          } else {
            this.position1 = 'in'
            this.position2 = 'in'
            this.position3 = 'in'
          }
        } else {
          if (hasAfter) {
            this.position1 = 'after'
            this.position2 = 'after'
            this.position3 = 'after'
          } else {
            this.position1 = 'none'
            this.position2 = 'none'
            this.position3 = 'none'
          }
        }
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('remove')
    },
    onDblClick () {
      this.$emit('clone')
    }
  }
}
</script>

<style>
.pcd-component-position{width:100%;margin:0 auto;text-align:center;table-layout:fixed;}
.pcd-component-position>tr>td:first-child{width:33%;}
.pcd-component-position>tr>td:last-child{width:33%;}
.pcd-component-position .el-icon-close{float:right;margin-right:2px;}
.pcd-component-position .el-icon-close:hover{color:#F56C6C;background:#F2F6FC}
.pcd-component-inline>.pcd-component-position{width:auto !important;}
.pcd-component-inline>.pcd-component-position>tr>td:first-child{width:50px;}
.pcd-component-inline>.pcd-component-position>tr>td:last-child{width:50px;}
</style>
